import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField,
    ISearchRequestSubset,
    ISearchSort
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";


var vUI_Period_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_PERIOD_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB Period Id',
            columnResourceName: 'colWBPeriodId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    PERIOD_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Period Id', columnResourceName: 'colPeriodId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    PERIOD_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Period Name', columnResourceName: 'colPeriodName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    PERIOD_START_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Period Start Date',
            columnResourceName: 'colPeriodStartDate',
            alignment: HorizAlignment.Center
        },
        domainOptions: {maxLength: 50}
    },
    PERIOD_END_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Period End Date',
            columnResourceName: 'colPeriodEndDate',
            alignment: HorizAlignment.Center
        },
        domainOptions: {maxLength: 50}
    },
    WB_PERIODM_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB Period M Id',
            columnResourceName: 'colWBPeriodMId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    PERIOD_TYPE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Period Type Name',
            columnResourceName: 'colPeriodTypeName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}
    },
    PERIOD_TYPE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Period Type ID',
            columnResourceName: 'colPeriodTypeID',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    WB_MDSET_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB MDSET Id',
            columnResourceName: 'colWbMdSetId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

class PeriodSearchByMDSetProvider
    implements ISearchProvider {
    _wbMDSetId: number = undefined

    constructor(wbMDSetId?: number) {
        this._wbMDSetId = wbMDSetId
    }

    keyFields = {
        id: 'WB_PERIOD_ID',
        id_ui: 'PERIOD_ID',
        name: 'PERIOD_NAME'
    }

    searchProviderFields = vUI_Period_Search_Fields

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            if (this._wbMDSetId > 0)
                searchOptions.where.WB_MDSET_ID = this._wbMDSetId

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Period_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }


    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let query: { where: { [id: string]: any } } = {where: {}}
            if (this._wbMDSetId > 0)
                query.where.WB_MDSET_ID = this._wbMDSetId

            let findRequest = SearchUtils.makeSearchRequest(query,
                'vUI_Period_Search',
                this.searchProviderFields,
                [fieldName])

            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            if (!usrContext.hasRoleId("VIEW_ALL")) {
                findRequest.where['WB_MDSET_ID'] = {inq: _.map(usrContext.WB_MasterDataSets, 'WB_MDSET_ID')}
            }

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => {
                        return aRow[fieldName]
                    }))
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

}


class PeriodSearchByMDSetProfile
    implements ISearchProfile {
    aSearchProvider: ISearchProvider = undefined
    profileId = "default"
    profileName = "Search by Id, Name"
    renderOptions: { ui5ResourceId: "PeriodSearchProfileByName" }

    profileFilter = [
        {profileFilterName: 'Id', searchProviderFieldId: 'PERIOD_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'PERIOD_NAME', renderOptions: {}},
        {profileFilterName: 'Period Type', searchProviderFieldId: 'PERIOD_TYPE_NAME', bMultiSelect: true, renderOptions: {}},
    ]  // ISearchFields
    profileDisplayFields = [
        'PERIOD_ID', 'PERIOD_NAME', 'PERIOD_START_DT', 'PERIOD_END_DT', 'PERIOD_TYPE_ID', 'PERIOD_TYPE_NAME',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ] //string[];   // Search Provider Field Name (Use to Generate Grid Columns)


    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault = ""   //string;
    profileSorts: ISearchSort[] = [] //ISearchSort[];

    constructor(wbMDSetId: number) {
        this.aSearchProvider = new PeriodSearchByMDSetProvider(wbMDSetId)
    }

    get profileSearchProvider() {
        return this.aSearchProvider
    }

}


export class PeriodSearchByMDSet
    implements ISearch {

    constructor(wbMDSetId?: number) {
        this.searchProfiles = [new PeriodSearchByMDSetProfile(wbMDSetId)]
    }

    searchName = "Select Period(s)"
    renderOptions = {ui5ResourceId: "PeriodSearchByMDSet"}
    searchProfileIdDefault = "default"
    searchProfiles: ISearchProfile[] = []
    autoSearch = true

}